export default {
  '场所':'Venue',
  '批量解绑':'Batch unbind',
  '已选中{selectedCount}人':'{selectedCount} people have been selected',
  '取消全部选中':'Cancel all selections',
  '解绑':'Unbind',
  '设备名、序列号模糊搜索':'Fuzzy search by device name and serial number',
  '机构名称':'Organization name',
  '机构代码':'Organization code',
  '设备名称':'Device name',
  '序列号':'Serial number',
  'MAC地址':'MAC address',
  '场所名称':'Venue name',
  '激活时间':'Activation time',
  '设备状态':'Device status',
  '是否确认批量解绑{selectedCount}个设备？':'Are you sure you want to batch unbind {selectedCount} devices?',
  '是否确认解绑设备{deviceName}？':'Are you sure you want to unbind the device {deviceName}?',
  '解绑成功！':'Unbind Success!',
  '软件版本':'Software version',
  '子设备':'Child device',
  '当前版本':'current version',
  '子设备列表':'Child device List',
  '子设备名称':'Child device Name',
  '序列号':'Serial Number',
  'MAC 地址':'MAC address',
  '激活时间':'Activation time',
  '应用及版本':'Application And Software Version',
  '设备详情':'​Device Detail',
  '设备信息':'​Device Information',
  '应用信息':'​App Information',
  '专注模式':'​​Focus Mode​​',
  '设置专注模式':'​​Focus Mode Setting',
  '专注时间':'​​Focus Time​',
  '确定关闭本设备的专注模式吗？':'Are you sure you want to turn off Focus Mode on this device?​',
  '仅支持部分设备':'Only supports selected devices: Fixed Test Station - Specialized (Running), Fixed Test Station - General (Indoor AI), Fixed Test Station - General (Indoor Sensor), Smart Screen devices',
}    